module.exports = __webpack_public_path__ + "img/宝钛集团LOGO.1b9b46db.png";